<template>
    <div  class="body-inner">
        <header-landing-component></header-landing-component>


        <div id="slider" class="inspiro-slider dots-creative" data-height-xs="360">
            <!-- Slide 2 -->
            <div class="slide kenburns" style="background-image:url('../../assets/images/ic3_bg_banner.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="slide-captions text-center text-light">
                        <!-- Captions -->
                        <span class="strong">Certificaciones</span>
                        <h1>IC3 Digital Literacy<br>
<span style="font-size: 2.55rem">CERTIFICATION</span></h1>
                        <!-- end: Captions -->
                    </div>
                </div>
            </div>
            <!-- end: Slide 2 -->

        </div>
        <!--end: Inspiro Slider -->

        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="heading-text heading-section">
                            <h2 style="font-size: 2.85rem">TODO COMIENZA CON<span style="color:#399500"> IC3</span> DIGITAL LITERACY</h2>

                        </div>
						<img src="../../assets/images/certificaciones/ic3.png" class="mb-4">
                    </div>
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-lg-10">
								
							<p>El programa de Certificación IC3 Digital Literacy está diseñado para garantizar que los estudiantes de todas las edades puedan no solo introducirse en nuestro mundo digital, sino también prosperar en él. No solo valida la capacidad de un estudiante de hacer más que simplemente consumir tecnología, sino que les permite comprender las posibilidades y establecer el conjunto de habilidades fundamentales necesarias para respaldar nuestra economía digital moderna.<br>
<br>
El camino a la tecnología de la información y la comunicación comienza con IC3 Digital Literacy.</p>
								<hr>
								<br>
								
								<h4>GLOBAL STANDARD SIX</h4>
								
								<ul class="list-icon list-icon-check">
									<li><strong>NIVEL 1: Conocer</strong> —
El examen del Nivel 1 certifica que los candidatos tienen los conocimientos fundamentales y las competencias básicas de la alfabetización digital en siete áreas de competencias.</li>

<li><strong>NIVEL 2: Hacer</strong> — El examen del Nivel 2 certifica la capacidad de un candidato de hacer tareas esenciales en un entorno en línea y en las aplicaciones principales en las siete áreas objetivo.</li>

<li><strong>NIVEL 3: Liderar</strong> — El examen del Nivel 3 certifica el dominio de la alfabetización digital de un candidato y su capacidad de administrar sistemas, colaborar y resolver problemas, así como también de guiar a otras personas.</li>
								
								</ul>
								
								<img src="../../assets/images/ic3-gs6.png" class="img-fluid">
							
							
							</div>

                         

                        </div>
                    </div>

                </div>
                <div class="row mt-5">
                    <div class="col-12 text-center">
                        <p class="gca-title-big">CERTIFICADO OFICIAL</p>
                    </div>
                    <div class="col-12 text-center">
                        <img src="../../assets/images/carousel/Sample_Certificate_IC3.png" alt="">
                    </div>
                </div>
            </div>
        </section>

		
		<section>
		 <div class="container">
			 
            <div class="row">
				
				<div class="col-md-4"><img src="../../assets/images/GDLCLogo2019-01.svg" class="img-fluid"></div>
				
				<div class="col-md-8">
					
					<h3>VERDADERAMENTE UN ESTÁNDAR GLOBAL</h3>
					
					<p>IC3 Digital Literacy trabaja conjuntamente con Global Digital Literacy Council, un organismo asesor de ejecutivos de la industria, educadores de tecnología y profesionales de evaluaciones, en la recopilación de datos de mercados laborales, ministerios de educación, agencias gubernamentales y organismos normativos internacionales, para garantizar que IC3 Digital Literacy esté siempre a la vanguardia de lo que significa la alfabetización digital.</p> </div>
				
				
                
              
               
            </div>
		 </div>
        </section>
		
		<section class="p-b-0">
		
			<div class="container">
				
				<h3 class="center-text">RESPALDOS INTERNACIONALES</h3>
				<p>
			IC3 Digital Literacy ha sido respaldada en todo el mundo al ayudar a estudiantes de todas las edades a validar sus habilidades y competencias de alfabetización digital. A continuación se indican las organizaciones internacionales que respaldan a IC3 Digital Literacy:</p>
			
			</div>
		
		</section>

        <section class="section-fullwidth text-light p-b-0 p-t-0">
            <div class="row">
                
              <img src="../../assets/images/ic3-respaldos.jpg" class="img-fluid">

               
            </div>
        </section>

        <!--call-to-action dark -->
        <div class="call-to-action p-t-100 p-b-100  mb-0 call-to-action-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10">
                        <h3>
                            ¿Quieres agregar esta credencial con validez internacional a tu CV?
                        </h3>
                        <p>
                            Conoce todas las soluciones que Global Certification Academy ofrece para agregar VALOR A TU CURRÍCULUM.
                        </p>
                    </div>
                    <div class="col-lg-2"><router-link class="btn btn-primary btn-lg" to="/register">INSCRIBIRME</router-link></div>
                </div>
            </div>
        </div>
        <!--end: call-to-action dark -->
        <LeadComponent></LeadComponent>
        <footer-landing-component></footer-landing-component>
    </div>

</template>

<script>
    import HeaderLandingComponent from "../../components/Landing/HeaderLandingComponent.vue"
    import FooterLandingComponent from "../../components/Landing/FooterLandingComponent.vue"
    import LeadComponent from "../../components/Landing/LeadComponent.vue"
    
	export default {
		name: 'ic3',
        components: {
			HeaderLandingComponent,
            FooterLandingComponent,
            LeadComponent
		},   
		data() {
			return {
            }
        },
		methods: {
        },
		mounted() {
        }        
    }

</script>